import { motion } from "framer-motion";
import { WelcomeSection } from "./components/WelcomeSection";
import { TokenUsageCard } from "./TokenUsageCard";
import { StatisticsSection } from "./components/StatisticsSection";
import { QuickStartGuide } from "./components/QuickStartGuide";

export function DashboardContent() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50/50 to-white backdrop-blur-sm w-full">
      <div className="container mx-auto px-4 py-6 space-y-6 max-w-7xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
        >
          <div className="col-span-1 md:col-span-2 lg:col-span-3">
            <WelcomeSection />
          </div>
          
          <div className="col-span-1 md:col-span-2 lg:col-span-2">
            <TokenUsageCard />
          </div>
          
          <div className="col-span-1 row-span-2">
            <QuickStartGuide />
          </div>
          
          <div className="col-span-1 md:col-span-2">
            <StatisticsSection />
          </div>
        </motion.div>
      </div>
    </div>
  );
}